<!-- 
  @desc 修改默认密码
-->
<template>
  <el-container class="main_panel" direction="vertical">
    <el-container direction="vertical" class="content_panel updatePwd_content">
      <el-row class="updatePwd_panel">
        <el-card>
          <div slot="header" class="panel_title">修改默认密码</div>
          <el-form
            ref="UpdateDefaultPasswordVO"
            :model="UpdateDefaultPasswordVO"
            :rules="$rules.defaultPasswordUpdate_rules"
            size="small"
          >
            <el-form-item prop="password">
              <el-input show-password v-model.trim="UpdateDefaultPasswordVO.password" placeholder="请输入新密码">
                <template slot="prepend">
                  <i class="el-icon-key"></i>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="rePassword">
              <el-input show-password v-model.trim="UpdateDefaultPasswordVO.rePassword" placeholder="请输入确认密码">
                <template slot="prepend">
                  <i class="el-icon-key"></i>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col :span="24">
              <el-button type="primary" @click="updatePwd" native-type="submit" size="small" class="updatePwd_btn">
                修改
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-row>
    </el-container>
  </el-container>
</template>
<script>
import { UpdateDefaultPasswordVO } from "@/libs/model";
export default {
  data() {
    return {
      UpdateDefaultPasswordVO: new UpdateDefaultPasswordVO()
    };
  },
  methods: {
    checkUpdatePwd(fun) {
      this.$refs["UpdateDefaultPasswordVO"].validate(valid => {
        if (valid) {
          fun(valid);
        }
      });
    },
    updatePwd() {
      this.checkUpdatePwd(() => {
        this.$http.defaultPasswordUpdate(this.UpdateDefaultPasswordVO).then(response => {
          var res = this.$http.data(response);
          if (this.$http.success(res)) {
            this.$message({
              message: "修改默认密码成功",
              type: "success"
            });
            // this.$store.commit("loginOut");
            this.$router.push("/management");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    }
  }
};
</script>
<style>
.updatePwd_content {
  position: relative;
  height: calc(100vh - 3rem);
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.updatePwd_panel {
  position: absolute;
  top: 40%;
  left: 50%;
  width: 23.25rem;
  transform: translate(-50%, -50%);
}
.updatePwd_btn {
  width: 100%;
  margin-bottom: 0.625rem;
}
.updatePwd_content .el-form-item--small.el-form-item {
  margin-bottom: 2rem;
}
/** 去除卡片圆角 */
.el-card {
  border-radius: 0;
}
</style>
